'use client';

import classnames from 'classnames';

import { RadioButton } from '../../forms';
import { Label } from '../layout/Label';
import { Title } from '../layout/Title';
import type {
  SelectableListItem,
  SelectableListProps,
} from './SelectableList.types';

import styles from './SelectableList.module.scss';

function SelectableList({
  style,
  className,
  title,
  items,
  onSelect,
  testId = 'ui-selectable-table',
}: SelectableListProps) {
  const checkActive = (item: SelectableListItem) => {
    return item.active === true;
  };

  return (
    <div
      style={style}
      className={classnames(styles['selectable-table'], className)}
      data-testid={testId}
    >
      <div className={styles['header']} data-testid={`${testId}_header`}>
        <span className={styles['header__title']}>{title}</span>
        <div className={styles['icon-wrapper']}>
          <RadioButton
            className={styles['button']}
            checked={items.every(checkActive)}
            onChange={() => {
              const active = !items.every(checkActive);
              items.forEach((item) => onSelect(item.id, active));
            }}
            disabled={items.every((item) => item.disabled)}
          />
        </div>
      </div>
      {items.map((item, index) => (
        <div
          className={styles['row']}
          key={index}
          data-testid={`${testId}_item-${index}`}
        >
          <div className={styles['title']}>
            {item.label && (
              <Label
                value={item.label.value}
                backgroundColor={item.label.backgroundColor}
              />
            )}
            <Title text={item.text} info={item.info} variant="bold" />
          </div>
          <div className={styles['icon-wrapper']}>
            <RadioButton
              className={styles['button']}
              checked={item.active}
              onChange={() => onSelect(item.id, !item.active)}
              disabled={item.disabled}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export { SelectableList };
